<div #tbl class="card" [ngClass]="{'he': currentLanguage === 'he'}">
  <div [ngClass]="{'table-wrapper':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en'}">
    <p-table #dt [value]="isLoading ? [] : entities" [first]="entityIndex"
      [lazy]="false" [paginator]="true" styleClass="p-datatable-gridlines rtl-table" [rows]="50"
      [scrollable]="!!entities.length" [scrollHeight]="!!entities.length ? 'calc(100dvh - 22rem)' : 'unset'"
      columnResizeMode="fit" [resizableColumns]="true" [columns]="cols" [loading]="isLoading"
      [loadingIcon]="'fa-solid fa-person-digging fa-shake'" [showCurrentPageReport]="!isLoading"
      (onPage)="handlePageChange($event)" (onFilter)="handleFilter($event)" (onValueChange)="clearFilters()"
      [currentPageReportTemplate]="currentLanguage=== 'he' ? 'מציג {first} עד {last} מתוך {totalRecords} רשומות' : '{first} to {last} of {totalRecords} records'">
      <ng-template pTemplate="header">
        <tr class="fixed-height-row table-titles grid-row">
          <ng-container *ngFor="let col of cols">
            <th *ngIf="col.field !== 'entityId'" pResizableColumn
              pSortableColumn="{{col.sortable ? col.field : undefined}}" class="header-col" [ngClass]="col.styleClass"
              [attr.aria-sort]="getSortOrder(col.field)">
              {{ col.header | translateLang | async }}
              <p-sortIcon *ngIf="entities.length > 0 && col.sortable" field="{{col.field}}"
                [attr.aria-label]="getSortAriaLabel(col.field)">
              </p-sortIcon>
            </th>
          </ng-container>
        </tr>
        <tr *ngIf="!isLoading && !!entities.length" class="grid-row">
          <ng-container *ngFor="let col of cols">
            <th *ngIf="col.field !== 'entityId'">
              <span *ngIf="col.filterable"
                [ngClass]="{'p-input-icon-left': currentLanguage === 'he', 'p-input-icon-right': currentLanguage === 'en'}">
                <i class="pi pi-filter" aria-hidden="true"></i>
                <input pInputText type="text"
                  [attr.aria-label]="('iaa.app.general.filterBy' | translate) + (col.header | translateLang | async)"
                  (input)="dt.filter($any($event.target).value, col.filterField || col.field, 'contains')"
                  [value]="$any(dt.filters[col.filterField || col.field])?.value">
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-entity let-rowData>
        <tr class="fixed-height-row grid-row">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="col.field !== 'entityId'" class="flex align-items-center justify-content-center"
              style="height: 54px;max-width: 100px;">
              <ng-container *ngIf="col.field === 'title'">
                <a *ngIf="entity.linkInfo || entity.downloadUrl;  else noLink" [attr.data-entity-id]="entity.entityId"
                  (click)="handleClickDetails(entity, $event)" 
                  (keydown.enter)="handleClickDetails(entity, $event)"
                  [attr.aria-haspopup]="'dialog'"
                  role="button" tabindex="0" class="title-link" tooltipEvent="both"
                  [pTooltip]="((entity.title | translateLang | async) ?? '')"
                  [attr.aria-label]="(entity.entityType === 'dana_pdf' || entity.entityType === 'decision_letters') ? 
                    (('iaa.aria.viewDocumentInViewer' | translate) + ': ' + ((entity.title | translateLang | async) ?? '')) : 
                    ((entity.title | translateLang | async) ?? '')">
                  {{(entity.title | translateLang | async) | slice:0:50}}
                </a>
                <ng-template #noLink>
                  <span [pTooltip]="((entity.title | translateLang | async) ?? '')">
                    {{(entity.title | translateLang | async) | slice:0:50}}
                  </span>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="col.field === 'shapes'">
                <div class="icon-cell">
                  <div class="flex align-items-center justify-content-center gap-2">
                    <span *ngIf="entity[col.field]?.length > 0 || entity.entityType === 'orthophoto'" class="sr-only">{{'iaa.app.results.resultsBody.resultsBodyList.viewOnMap' | translate}}</span>
                    <span *ngIf="entity[col.field]?.length > 0 || entity.entityType === 'orthophoto'" (click)="goToMap(rowData)" (keydown.enter)="goToMap(rowData)"
                      tabindex="0"
                      role="button"
                      [attr.aria-label]="'iaa.app.results.resultsBody.resultsBodyList.viewOnMap' | translate"
                      style="cursor: pointer; display: inline-flex; align-items: center;">
                      <img [src]="'assets/entity-location-gold.svg'" [attr.aria-label]="'iaa.app.general.mapIcon' | translate" width="17" height="19"
                        class="map-icon" style="display: block;">
                    </span>
                    <i *ngIf="entity.entityType === 'photogrammetric_model' && entity.downloadUrl && internalUser" class="pi pi-download" 
                      (click)="menuItemsService.downloadFile(entity)"
                      (keydown.enter)="menuItemsService.downloadFile(entity)" 
                      tabindex="0" 
                      role="button"
                      [attr.aria-label]="'iaa.app.general.download' | translate"
                      style="cursor: pointer; color: #B99A60; font-size: 19px; display: inline-flex; align-items: center; line-height: 1;"></i>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="col.field === 'menu'">
              </ng-container>
              <ng-container *ngIf="col.field !== 'title' && col.field !== 'shapes' && col.field !== 'ellipsis'">
                <bdi [pTooltip]="((entity[col.field] | translateLang | async) ?? '')">
                  <div *ngIf="((entity[col.field] | translateLang | async) ?? '')">
                    <bdi [pTooltip]="((entity[col.field] | translateLang | async) ?? '')">
                      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                       <bdi>{{((entity[col.field] | translateLang | async) ?? '')}}</bdi> 
                      </div>
                    </bdi>
                  </div>
                </bdi>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr class="fixed-height-row skeleton-wrapper grid-row" *ngFor="let row of Array.from({ length: 20 })">
          <td *ngFor="let row of Array.from({ length: cols.length - 1})">
            <p-skeleton />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-hover" style="height: 53vh;">
          <td [attr.colspan]="columns.length">
            <div class="text-center">
              <p class="text-5xl">{{
              ('iaa.app.results.noResults' | translate)
              }}</p>
            </div>
          </td>
        </tr>
        <div aria-live="polite" class="sr-only">
          <p>
            {{currentLanguage === 'he'}} ?
            מציג {{ (dt?.first ?? 0) + 1 }} עד {{ (dt?.first ?? 0) + (dt?.rows ?? 0) }} מתוך {{ dt?.totalRecords ?? 0 }}
            רשומות
            :{{ (dt?.first ?? 0) + 1 }} to {{ (dt?.first ?? 0) + (dt?.rows ?? 0) }} of {{ dt?.totalRecords ?? 0
            }} records
          </p>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>